import styled, { css } from 'styled-components';

export const InputContainer = styled.div<{
  $error?: string;
}>`
  position: relative;
  height: 53px;
  margin-bottom: 33px;
  border-bottom: 2px solid
    ${({ $error, theme }) =>
      $error ? theme.colors.lightRed : theme.colors.darkBlueV2};
  box-sizing: border-box;
  width: 33px;

  @media (height <= 769px) {
    margin-bottom: 20px;
  }

  @media (width <= 450px) {
    width: 40px;
  }

  @media (width <= 370px) {
    width: 35px;
  }

  @media (width <= 330px) {
    width: 30px;
  }
`;

export const CodeForm = styled.div<{ $codeLength: number }>`
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: ${({ $codeLength }) => `repeat(${$codeLength}, 1fr)`};
  column-gap: 19.3px;
  height: 46px;
  width: 100%;

  input[type='email'] {
    display: none;
  }
`;

export const FormLabel = styled.label<{
  $active: boolean;
  $error?: string;
  $isCursorPointer?: boolean;
}>`
  &::first-letter {
    text-transform: uppercase;
  }

  color: ${({ theme, $active }) =>
    $active ? theme.colors.darkBlue : theme.colors.darkBlueV2};
  font-size: ${({ $active }) => ($active ? '12px' : '14px')};
  line-height: 18px;
  font-weight: 400;
  position: absolute;
  transition:
    all 0.5s,
    color 0s;
  z-index: 5;
  top: ${({ $active }) => ($active ? '3px' : '22px')};
  cursor: ${({ $active }) => ($active ? 'default' : 'text')};
  ${({ $error: error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.lightRed};
    `}

  ${({ $isCursorPointer }) =>
    $isCursorPointer &&
    css`
      cursor: pointer;
    `}
`;

export const FormInput = styled.input<{
  $error?: string;
}>`
  width: 100%;
  height: 100%;
  font-size: 16px;
  text-align: center;
  outline: none;
  border: none;
  font-weight: 300;
  border-radius: 5px;
  background: none;
  padding: 6px 0 0;
  color: ${({ $error, theme }) =>
    $error ? theme.colors.lightRed : theme.colors.darkBlueV2};

  &::-webkit-inner-spin-button {
    display: none;
  }
`;

export const CodeContainer = styled.div`
  margin: 0 auto;
`;

export const PreviewContainer = styled.div`
  position: absolute;
  inset: 0 0 -6px;
  cursor: text;
  border-bottom: 2px solid ${({ theme }) => theme.colors.darkBlueV2};
`;
